export const FETCH_CATEGORIES_REQUEST = 'categories/FETCH_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'categories/FETCH_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'categories/FETCH_FAILURE';

export default () => {
  return (dispatch, getState, { request }) => {
    dispatch({
      type: FETCH_CATEGORIES_REQUEST,
    });

    return request('/_api/categories')
      .then(categories =>
        dispatch({
          type: FETCH_CATEGORIES_SUCCESS,
          payload: categories,
        })
      )
      .catch(() =>
        dispatch({
          type: FETCH_CATEGORIES_FAILURE,
        })
      );
  };
};



// WEBPACK FOOTER //
// ./app/actions/fetch-categories.js